module.exports = __webpack_public_path__ + "static/bug-light-zoom-462b38396e78ec4a70155c5524be583f.jpg";